import React from "react";
import { useRef } from "react";

import images from "@/utils/images";
import { useClickOutside } from "@/utils/hooks/useClickOutside";

const MemberProfileStatusPopUp = ({ closePopup, isOpen, openPopup, popUpOptions }) => {
  const ref = useRef();
  const internalPopUpOptions = popUpOptions.filter((option) => {
    if (option.shouldShow && !option.shouldShow()) {
      return false;
    }

    return true;
  });

  // close the popup if we click outside of it
  useClickOutside(ref, () => {
    if (isOpen) {
      closePopup();
    }
  });

  // if there are no available popup options do not show anything
  if (internalPopUpOptions.length === 0) {
    return null;
  }

  return (
    <div className="MemberProfileStatusPopUp__wrapper">
      <button className="MemberProfileStatusPopUp__button" onClick={openPopup}>
        <img alt="patient-menu-drop-down" src={images("./common/chevronV2Green.svg")} />
      </button>
      {isOpen && (
        <div className="MemberProfileStatusPopUp__dropdown" ref={ref}>
          {internalPopUpOptions.map((option, index) => {
            return (
              <button
                className="MemberProfileStatusPopUp__dropdown__item"
                key={option.id || option.title || index}
                onClick={() => {
                  option.action();
                  closePopup();
                }}
              >
                {option.title}
              </button>
            );
          })}
        </div>
      )}
    </div>
  );
};

export default MemberProfileStatusPopUp;
